<template>
  <b-input-group-prepend>
    <b-button
      :disabled="addLegenditemsDisabled"
      size="sm"
      variant="info"
      class="font-weight-bold"
      @click="addLegendItem"
    >
      <font-awesome-icon icon="plus" />
    </b-button>
  </b-input-group-prepend>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { ComparisonGraphCategory, ComparisonGraphLegendItem } from '@/types'

const props = {
  categories: {
    type: Array as PropType<ComparisonGraphCategory[]>,
    required: true,
  },
  legenditems: {
    type: Array as PropType<ComparisonGraphLegendItem[]>,
    required: true,
  },
  v: {
    type: Object,
    required: true,
  },
}

@Component
export default class AddLegendItem extends Vue.extend({ props }) {
  newColumn = 'New Column'

  get addLegenditemsDisabled () {
    return this.legenditems.length >= 3
  }

  get getNewLegenditemsLabel () {
    const sortedNewColumnIds = this.legenditems
      .filter(({ label }) => label.toString().includes(this.newColumn))
      .sort(({ label: a }, { label: b }) => a.localeCompare(b, 'en', { numeric: true }))
    if (sortedNewColumnIds.length === 0) return `${this.newColumn} 1`

    const lastNewColumnId = sortedNewColumnIds[sortedNewColumnIds.length - 1].label
    const newColumnId = parseInt(lastNewColumnId.replace(this.newColumn, ''))

    return `${this.newColumn} ${newColumnId + 1}`
  }

  addLegendItem () {
    this.legenditems.push({
      label: this.getNewLegenditemsLabel.toString(),
      color: '#cccccc',
    })
    this.categories.forEach(category => {
      category.fields.push('')
    })
    this.v.$touch()
  }
}

</script>
